import React from "react";
import uuid from "react-uuid";
import pin from "../images/pin.png";

const Profile = () => {
  const tags = [
    {
      name: "Web Developer",
      icon: "",
      color: "",
    },
    {
      name: "React Developer",
      icon: "",
      color: "",
    },
    {
      name: "Open to collaborate",
      icon: "",
      color: "",
    },
  ];
  return (
    <div className="profile-wrapper">
      <div className="name">
        <h3>Samiul Ahmed Anik</h3>
      </div>
      <div className="location">
        <img src={pin} alt={pin} /> Tilkatoli , Motijheel , Dhaka , Bangladesh
      </div>
      <div className="designation">
        <h6>Software Engineer & Programming Enthusiast</h6>
        <ul>
          {tags.map((tag) => (
            <li key={uuid()}>{tag.name}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Profile;
